module.exports = __webpack_public_path__ + "img/phase1-2011-02.ee8e32a9.jpg";